<div class="content-card">
  <div class="card-header">
    <h3>Configuration</h3>
  </div>
  <div class="card-body">
    @if (serviceNowForm.get('username') && serviceNowForm.get('password') && serviceNowForm.get('instanceUrl')) {
      <form [formGroup]="serviceNowForm" class="config-form">
        <div class="mb-4">
          <kendo-label [for]="snUsername" text="Username" [optional]="false"></kendo-label>
          <kendo-textbox formControlName="username" #snUsername class="w-100"></kendo-textbox>
          @if (serviceNowForm.get('username')?.invalid && serviceNowForm.get('username')?.touched) {
            <div class="text-danger mt-1">
              Username is required
            </div>
          }
        </div>
        
        <div class="mb-4">
          <kendo-label [for]="snPassword" text="Password" [optional]="false"></kendo-label>
          <kendo-textbox formControlName="password" #snPassword type="password" class="w-100"></kendo-textbox>
          @if (serviceNowForm.get('password')?.invalid && serviceNowForm.get('password')?.touched) {
            <div class="text-danger mt-1">
              @if (serviceNowForm.get('password')?.errors?.['required']) {
                Password is required
              } @else if (serviceNowForm.get('password')?.errors?.['minlength']) {
                Password must be at least 8 characters
              }
            </div>
          }
        </div>
        
        <div class="mb-4">
          <kendo-label [for]="snInstanceUrl" text="Instance URL" [optional]="false"></kendo-label>
          <kendo-textbox formControlName="instanceUrl" #snInstanceUrl class="w-100"></kendo-textbox>
          @if (serviceNowForm.get('instanceUrl')?.invalid && serviceNowForm.get('instanceUrl')?.touched) {
            <div class="text-danger mt-1">
              @if (serviceNowForm.get('instanceUrl')?.errors?.['required']) {
                Instance URL is required
              } @else if (serviceNowForm.get('instanceUrl')?.errors?.['pattern']) {
                Instance URL must be a valid URL (http:// or https://)
              }
            </div>
          }
        </div>

        <div class="mb-4 checkbox-container">
          <input type="checkbox" formControlName="supportsMultiTenant" id="snMultiTenantCheckbox" class="form-check-input">
          <label for="snMultiTenantCheckbox" class="ms-2 form-check-label">Supports Multi-Tenant</label>
        </div>

        <div class="form-actions">
          <button kendoButton [primary]="true" (click)="onTestConnection()"
            [disabled]="serviceNowForm.invalid || loading" class="k-button-solid-primary">
            @if (icons['checkOutline']) {
              <kendo-svgicon [icon]="icons['checkOutline']" class="me-1"></kendo-svgicon>
            }
            Test Connection
          </button>
          <button kendoButton (click)="onSaveConfiguration()" [disabled]="serviceNowForm.invalid || loading"
            class="ms-2">
            @if (icons['save']) {
              <kendo-svgicon [icon]="icons['save']" class="me-1"></kendo-svgicon>
            }
            Save Configuration
          </button>
        </div>
      </form>
    } @else {
      <div class="loading-state">
        <p>Loading configuration...</p>
      </div>
    }
  </div>
</div>
